import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-virsa-insight",
  templateUrl: "./virsa-insight.component.html",
  styleUrls: ["./virsa-insight.component.scss"],
})
export class VirsaInsightComponent {
  insight = [
    {
      name1: "Live",
      name2: " Activities",
      image: environment.assUrl + "assets/images/homepage/insight1.png",
      details:
        "Experience life-transforming activities guided by experts in performing arts. These live sessions bring cultural richness to your daily routine.",
    },
    {
      name1: "Easy",
      name2: " Access",
      image: environment.assUrl + "assets/images/homepage/insight2.png",
      details:
        "Learn at your own pace and convenience. Virsa offers flexibility so you can explore the best content on your schedule.",
    },
    {
      name1: "Best",
      name2: " Content",
      image: environment.assUrl + "assets/images/homepage/insight3.png",
      details:
        "Unlock access to India's premier Performing Arts Program, enhancing not just your skills but your personal growth journey.",
    },
    {
      name1: "Expert",
      name2: " Trainers",
      image: environment.assUrl + "assets/images/homepage/insight4.png",
      details:
        "Our accomplished trainers provide expert guidance. With their mentorship, you can master the art form of your choice.",
    },
  ];
}
